/**
 * Highlights section (used for 2020 Highlights, PAGE Impact on Homepage)
 */

import React from "react"
import { Link } from "gatsby"
import parse from "html-react-parser"
import { kebabCase } from "lodash"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Modal from "./modal"
import Expandable from "./expandable"
import CopyLinkButton from "./copy-link-button"
import MultipleItemSlider from "./slider"

const Highlights = ({ props, annualReport, index, hasMenu }) => {
  const { heading, backgroundColor, backgroundColorAr: backgroundColorSection, format, columnCount, includeInStickyMenu, leadContent, leadContentSize, modalOrExpandable, includeIcons } = props
  const overlay = format === "scroll" && index === 0 && !hasMenu
  return (
    <section
      key={heading || includeInStickyMenu?.menuTitle}
      className={`section relative p-section 
      ${annualReport === "2024" ? (` ${backgroundColorSection === "white" ? "bg-white" : `bg-cover ${backgroundColorSection === "blue" ? "bg-circles-only-blue" :
          backgroundColorSection === "green" ? "bg-circles-green" : backgroundColorSection === "gray" ? "bg-gray-200" :
            backgroundColorSection === "teal" ? "bg-circles-teal" : "bg-white"}`}`) :
          annualReport === "2023" ? (` ${backgroundColorSection === "white" ? "bg-white" : `bg-cover bg-white/60 bg-blend-lighten ${backgroundColorSection === "blue" ? "bg-blue-blobs" :
            backgroundColorSection === "green" ? "bg-green-blobs" : backgroundColorSection === "gray" ? "bg-gray-200" :
              backgroundColorSection === "teal" ? "bg-teal-blobs" : "bg-white"}`}`)
            : annualReport === "2022" ? (backgroundColorSection === "white" ? "bg-white" : backgroundColorSection === "blue" ? "bg-blue-100" :
              backgroundColorSection === "green" ? "bg-green-100" : backgroundColorSection === "gray" ? "bg-gray-200" :
                backgroundColorSection === "teal" ? "bg-teal-50" : "bg-white")
              : backgroundColor && backgroundColor !== "transparent"
                ? "bg-gradient-to-b print:from-transparent " +
                (backgroundColor === "blue-100"
                  ? "from-blue-300 "
                  : backgroundColor === "green-100"
                    ? "from-green-300"
                    : "")
                : "bg-transparent m-section"
        }`}
    >
      <div className={`${overlay ? "sm:bg-white sm:-mt-28 relative sm:rounded container sm:pt-8" : ""}`}>
        <div className={`${overlay ? "pl-4 sm:pl-8" : format === "scroll" ? "container pl-12" : `container`} 
        ${annualReport === "2024" ? `pb-8 text-center ${(backgroundColorSection === "blue" || backgroundColorSection === "teal" || backgroundColorSection === "green") ? "text-white" : ""}` : ""}
        ${annualReport === "2022" ? `border-l-6 pl-4 relative ${backgroundColorSection === "white" || backgroundColorSection === "blue" ? "border-l-blue" :
            backgroundColorSection === "green" || backgroundColorSection === "gray" ? "border-l-green" :
              backgroundColorSection === "teal" ? "border-l-teal" : "border-l-blue"}` : ""}`}>
          <div className="group-copy-link group grid grid-cols-1 justify-start">
            {heading ? (
              <>
                <h2
                  className={`anchor-heading 
                    leading-snug
                    ${columnCount === 1 && format !== "scroll"
                      ? "max-w-5xl w-full mx-auto"
                      : ""
                    }`}
                  id={kebabCase(heading).replace(/[0-9]/g, "")}
                >
                  {heading}
                </h2>
                <CopyLinkButton heading={heading} />
              </>
            ) : includeInStickyMenu?.menuTitle ? (
              <div id={kebabCase(includeInStickyMenu.menuTitle) || ""}>
                <CopyLinkButton heading={includeInStickyMenu.menuTitle} />
              </div>
            ) : null}
            {leadContent ? (
              <div
                className={`parsed-content mt-4 ${includeIcons ? "-mb-4" : ""
                  } ${leadContentSize === "base" ? "" : "lead-content"} ${columnCount === 1 && format !== "scroll"
                    ? "max-w-5xl mx-auto w-full"
                    : ""
                  }`}
              >
                {parse(leadContent)}
              </div>
            ) : null}
          </div>
        </div>
        {format === "scroll" ?
          <div className={`mt-4 ${annualReport === "2024" ? `${(backgroundColorSection === "blue" || backgroundColorSection === "teal" || backgroundColorSection === "green") ? "slick-dark" : ""} ` : ""}`}>
            <MultipleItemSlider overlay={overlay}>
              {props.highlights?.map(highlight => {
                return (
                  <div className={`px-4 ${annualReport === "2023" && backgroundColorSection === "white" ? "bg-cover hover:bg-white/80 bg-blend-lighten hover:bg-blue-blobs" : ""}`}>
                    <Highlight props={props} highlight={highlight} annualReport={annualReport} />
                  </div>
                )
              })}
            </MultipleItemSlider>
          </div>
          : <ul
            className={`mt-4 mx-auto ${modalOrExpandable === "expandable"
              ? `gap-x-8 gap-y-8 lg:gap-x-8 2xl:gap-x-16`
              : "gap-x-8 2xl:gap-x-16 "
              }
              ${`grid container ${columnCount === 1
                ? "max-w-5xl"
                : columnCount === 3
                  ? "md:grid-cols-2 lg:grid-cols-3"
                  : columnCount === 4
                    ? "md:grid-cols-2 lg:grid-cols-4"
                    : "lg:grid-cols-2"}`
              }`}
          >

            {props.highlights?.map(highlight => {
              return (
                <Highlight props={props} highlight={highlight} annualReport={annualReport} />
              )
            })}
          </ul>}
      </div>
    </section>
  )
}

export default Highlights
function Highlight({ props, highlight, annualReport }) {
  const { backgroundColor, backgroundColorAr: backgroundColorSection, format, columnCount, modalOrExpandable, includeIcons, iconSize } = props
  const { icon, iconFit } = highlight
  const image = {
    src: icon?.localFile
      ? getImage(icon?.localFile)
      : null,
    extension: icon?.localFile?.extension,
    alt: icon?.altText || ``,
    publicURL: icon?.localFile?.publicURL,
  }
  let maxWidthClass = `${iconSize === "1/1" ? "aspect-square" : "aspect-video"} max-w-xs md:max-w-full`
  let printClass = ""
  if (
    icon?.localFile?.publicURL
      ?.toLowerCase()
      .includes("icon")
  ) {
    maxWidthClass = "w-16 print:mb-2"
  }
  if (
    icon?.localFile?.publicURL
      ?.toLowerCase()
      .includes("goal")
  ) {
    maxWidthClass = "print:w-44"
    printClass = "print-break"
  }
  return <li
    className={`section highlight py-6 print:bg-transparent ${printClass}                   
                ${annualReport === "2024" ? "bg-white rounded-lg px-6 mb-4 font-inter" : modalOrExpandable === "modal"
        ? ""
        : includeIcons
          ? ""
          : annualReport ? `border-l-6 border-b-6 px-4 rounded-md relative 
                      ${backgroundColorSection === "white" ? "bg-blue-100" : backgroundColorSection === "blue" || backgroundColorSection === "green" || backgroundColorSection === "gray" || backgroundColorSection === "teal" ? "bg-white" : "bg-white"}
                      ${backgroundColorSection === "white" || backgroundColorSection === "blue" ? "border-blue" :
              backgroundColorSection === "green" || backgroundColorSection === "gray" ? "border-green" :
                backgroundColorSection === "teal" ? "border-teal" : "border-blue"}` : "bg-gray-700 bg-opacity-5 px-6 rounded-md"}`}
    key={highlight.heading}
  >
    <div
      className={`${includeIcons && columnCount < 3 && format !== "scroll"
        ? "grid grid-cols-4 gap-x-4"
        : ""} ${modalOrExpandable === "modal"
          ? "sm:items-center"
          : ""}`}
      key={highlight.heading}
    >
      {includeIcons ? (
        <div className={`relative ${annualReport === "2024" ? "rounded-lg" : ""} ${includeIcons && columnCount < 3 && format !== "scroll" ? "my-2.5" : "mb-2"}`}>
          {image?.extension !== "svg" ? (
            <GatsbyImage
              image={image.src}
              className={`${maxWidthClass}`}
              alt={image.alt}
              objectFit={iconFit === "contain" ? "contain" : "cover"} />

          ) : image?.publicURL ? (
            <img
              src={image.publicURL}
              className={`w-full h-full ml-auto print:ml-0 ${maxWidthClass} ${iconFit === "contain" ? "object-contain" : "object-cover"}`}
              alt={image.alt} />
          ) : null}
        </div>
      ) : null}
      {modalOrExpandable === "modal" ? (
        <div
          className={`${includeIcons && format !== "scroll" ? "col-span-3" : ""}`}
        >
          <div>
            {highlight.heading ? (
              <h3
                className={`mb-2 leading-snug ${annualReport === "2024" ? "text-ar24-blue-900" : ""}`}
              >
                {highlight.heading}
              </h3>
            ) : null}
            {highlight.content ? (
              <div
                className="parsed-content print:hidden"
              >
                {parse(highlight.content)}
              </div>
            ) : null}
            {highlight.content && !highlight.modalContent ? (
              <div className="parsed-content hidden print:block">
                {parse(highlight.content)}
              </div>
            ) : null}
          </div>
          <div>
            {highlight.modalContent ? (
              <Modal
                modalContent={highlight.modalContent}
                heading={highlight.heading}
                buttonText={highlight.buttonText}
                buttonColor={backgroundColorSection || backgroundColor}
                buttonSize="sm"
                annualReport={annualReport}
              ></Modal>
            ) : null}
            {highlight.button ? (
              <p>
                <Link
                  className={`btn-sm mt-2 ${backgroundColor === "white" || backgroundColor === "blue" ? "btn-blue" :
                    backgroundColor === "green" || backgroundColor === "gray" ? "btn-green" :
                      backgroundColor === "teal" ? "btn-teal" : "btn-blue"}`}
                  to={highlight.button.url}
                  target={highlight.button.target}
                >
                  {highlight.button.title}
                </Link>
              </p>
            ) : null}
          </div>
        </div>
      ) : (
        <div
          className={`${includeIcons && format !== "scroll" ? "col-span-3" : ""} ${!highlight.expandedContent ? "flex items-center" : ""}`}
        >
          <Expandable props={highlight}></Expandable>
        </div>
      )}
    </div>
  </li>
}

